import { isEmpty } from 'lodash';
import { APP_URL } from '../config';

export const imageWithParams = ({ image, params, height, width, fit }) => {
  if (!image) return null;
  if (image.indexOf('.ico') !== -1 || image.indexOf('.svg') !== -1) return image;

  let gravity = {};
  let newFit = fit || 'cover';

  if (!isEmpty(params)) {
    if (params.gravity) {
      gravity = params.gravity;
    }
  }

  const url = `${APP_URL}cdn-cgi/image/fit=${newFit},sharpen=1,quality=85,${width ? `width=${width}` : ''},${height ? `height=${height}` : ''}${!isEmpty(gravity) ? `,gravity=${gravity.x}x${gravity.y}` : ''}/${image}`;

  return url;
};